import { render, staticRenderFns } from "./Port.vue?vue&type=template&id=02068386&scoped=true"
import script from "./Port.vue?vue&type=script&lang=js"
export * from "./Port.vue?vue&type=script&lang=js"
import style0 from "./Port.vue?vue&type=style&index=0&id=02068386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02068386",
  null
  
)

export default component.exports